"use client";

import { type ReactNode, useRef } from "react";

import { useCcPrefersReducedMotion } from "@/lib/use-cc-prefers-reduced-motion";

import { useShowcaseShellHeight } from "./useShowcaseShellHeight";

type CcShowcaseHeightShellProps = {
  shellClassName?: string;
  innerClassName: string;
  children: ReactNode;
  /** Passed to ResizeObserver remount when tab panels or copy changes. */
  remeasureKey?: unknown;
};

/**
 * Clips and animates height when inner demo/showcase content changes (tab switch,
 * stacked panels settling to tallest). Disabled when prefers-reduced-motion.
 */
export function CcShowcaseHeightShell({
  shellClassName,
  innerClassName,
  children,
  remeasureKey,
}: CcShowcaseHeightShellProps) {
  const prefersReducedMotion = useCcPrefersReducedMotion();
  const shellRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useShowcaseShellHeight(shellRef, innerRef, prefersReducedMotion, remeasureKey);

  const shellClass = ["cc-showcase-height-shell", shellClassName].filter(Boolean).join(" ");

  return (
    <div ref={shellRef} className={shellClass}>
      <div ref={innerRef} className={innerClassName}>
        {children}
      </div>
    </div>
  );
}
